import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "quoteright" }
const _hoisted_2 = { class: "quickcart" }
const _hoisted_3 = { class: "sticky-quickcart" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Your Quote", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "line-item"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "Policy Length", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Renters Insurance", -1)
const _hoisted_10 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "line-item"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "Coverage Start", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, "Your liability", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, "Personal Property Coverage", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "Deductible", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "Huricane deductible", -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, "Replacement Cost", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, "Included", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "Water Sewer Backup", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "Added", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { key: 3 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, "Fraud Expense Protection", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, "Added", -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { key: 4 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, "Earthquake", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, "Added", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("strong", null, "Accidental Damage Personal Property Coverage (Add-On)", -1)
const _hoisted_36 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "line-item"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, "Coverage Start", -1)
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, "Include", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, "✓", -1)
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", null, "Coverage", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", null, "Deductible", -1)
const _hoisted_44 = { class: "total" }
const _hoisted_45 = { class: "paymentplan" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Payment Breakdown")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("b", null, "Renters Insurance", -1)
const _hoisted_49 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", null, "Payment Due Today:", -1)
const _hoisted_52 = {
  align: "right",
  valign: "top"
}
const _hoisted_53 = { key: 1 }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = {
  align: "right",
  valign: "top"
}
const _hoisted_56 = { key: 2 }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = {
  align: "right",
  valign: "top"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("b", null, "Accidental Damage Add-on", -1)
const _hoisted_63 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_64 = { key: 0 }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_66 = { key: 0 }
const _hoisted_67 = {
  align: "right",
  valign: "top"
}
const _hoisted_68 = { key: 1 }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = { key: 0 }
const _hoisted_71 = {
  align: "right",
  valign: "top"
}
const _hoisted_72 = { key: 2 }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", null, "11 monthly installments", -1)
const _hoisted_74 = {
  align: "right",
  valign: "top"
}

import { LocalDate, DateTimeFormatter } from "@js-joda/core";
import { Quote } from "@/models/Quote";
import { PaymentOptions } from "@/models/QuoteInsurance";
import {
  calculateQuoteTotal,
  formatAmountWithoutCents,
  formatAmount,
} from "@/utils/Utils";
import { Defaults } from "@/models/Defaults";
import { addNoScroll, removeNoScroll } from "@/utils/NoScroll";
import { inject, onMounted, onBeforeUnmount } from "vue";
import { ref, computed, Ref, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteCart',
  setup(__props) {

const shouldShowMobileCart: Ref<boolean> = ref(false);
const inj = inject("$emitter");
const quote = useQuoteStore();

onMounted(() => {
  window.addEventListener("popstate", onPopState);
  (inj as any).on("show-mobile-cart", () => {
    showMobileCart.value = true;
  });
});
onBeforeUnmount(() => {
  // remove the event listener
  window.removeEventListener("popstate", onPopState);
  (inj as any).off("show-mobile-cart", () => {
    showMobileCart.value = false;
  });
});

const showMobileCart = computed({
  get: () => shouldShowMobileCart.value,
  set: (value: boolean) => {
    shouldShowMobileCart.value = value;
    if (value) {
      addNoScroll();
    } else {
      removeNoScroll();
    }
  },
});

function hideMobileCart() {
  showMobileCart.value = false;
}

const quoteTotal: ComputedRef<number> = computed(() => {
  return calculateQuoteTotal(quote);
});

//Function not used
// function onQuoteChanged(): void {
//   const num = quoteTotal.valueOf();
// }

function formatDate(value: string) {
  if (value) {
    return LocalDate.parse(value).format(
      DateTimeFormatter.ofPattern("M/d/yyyy")
    );
  }
}

const currentDate: ComputedRef<string> = computed(() => {
  return LocalDate.now()
    .plusDays(1)
    .format(DateTimeFormatter.ofPattern("M/d/yyyy"));
});

// function formatAmountWithoutCents(value: number): string {
//   return formatAmountWithoutCents(value);
// }
//TODO export formatAmount in utils helper, pure function
// function formatAmount(value: number): string {
//   const num = Number(value);
//   // Create our number formatter.
//   const formatter = new Intl.NumberFormat("en-US", {
//     style: "currency",
//     currency: "USD",

//     // These options are needed to round to whole numbers if that's what you want.
//     //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
//     //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
//   });

//   return num ? formatter.format(num) : "N/A";
// }

//function not used
// function formatPaymentOption(value: any) {
//   const num = Number(value) as PaymentOptions;
//   switch (num) {
//     case PaymentOptions.Monthly:
//       return "Monthly";
//     case PaymentOptions.Annual:
//       return "Annual";
//     case PaymentOptions.FourPay:
//       return "4 Pay";
//     default:
//       return "Unknown";
//   }
// }

const processingFee: ComputedRef<number> = computed(() => {
  if (quote.personalInsurance.paymentOption == PaymentOptions.None) {
    return 0;
  }
  return quote.personalInsurance.paymentOption == PaymentOptions.Monthly
    ? quote.monthlyProcessingFee
    : quote.processingFee;
});

/**
 * Back or forward button has been clicked on browser.
 */
function onPopState() {
  // Remove no scroll, so when we return to the main window it can scroll
  removeNoScroll();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "viewcart",
      class: _normalizeClass({ show: showMobileCart.value })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (hideMobileCart()))
        }, "X"),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_7,
                _createElementVNode("td", null, _toDisplayString(_unref(quote).info.policyLength) + " Year", 1)
              ])
            ])
          ]),
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("table", _hoisted_10, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", null, _toDisplayString(formatDate(_unref(quote).info.coverageStartDate)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", null, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .liabilityAmount
                    )), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_13,
                _createElementVNode("td", null, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .personalPropertyAmount
                    )), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", null, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails.deductible
                    )), 1)
              ]),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.hurricaneDeductible !== null)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("td", null, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .hurricaneDeductible
                    )), 1)
                  ]))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.replacementCost)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_20))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.waterBackup)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, _hoisted_24))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.identityFraud)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_25, _hoisted_28))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.earthquake)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_29, _hoisted_32))
                : _createCommentVNode("", true)
            ])
          ]),
          (_unref(quote).hasPersonalInsurance && _unref(quote).showAddonOnCart)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _hoisted_35,
                _createElementVNode("table", _hoisted_36, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_37,
                      _createElementVNode("td", null, _toDisplayString(_unref(quote).hasPersonalInsurance ? currentDate.value : "N/A"), 1)
                    ]),
                    (_unref(quote).hasPersonalInsurance)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_38, _hoisted_41))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _hoisted_42,
                      _createElementVNode("td", null, _toDisplayString(_unref(quote).hasPersonalInsurance
                        ? _unref(formatAmountWithoutCents)(
                            _unref(quote).personalInsurance.coverageAmount
                          )
                        : "N/A"), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_43,
                      _createElementVNode("td", null, _toDisplayString(_unref(quote).hasPersonalInsurance
                        ? _unref(formatAmountWithoutCents)(
                            _unref(quote).personalInsurance.deductibleAmount
                          )
                        : "N/A"), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_44, [
            _createTextVNode(" Due Today: "),
            _createElementVNode("b", null, _toDisplayString(_unref(formatAmount)(quoteTotal.value)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _hoisted_46,
        _hoisted_47,
        _hoisted_48,
        _createElementVNode("table", _hoisted_49, [
          _createElementVNode("tbody", null, [
            (_unref(quote).rentersInsurance.dueToday)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("td", _hoisted_52, _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.dueToday)), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(quote).rentersInsurance.paymentOption == 1)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(_unref(quote).rentersInsurance.numberOfPayments - 1) + " monthly installments", 1),
                    _hoisted_54,
                    _createElementVNode("em", null, "Includes " + _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.installmentAmount)) + " + " + _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.serviceFee)) + " billing fee ", 1)
                  ]),
                  _createElementVNode("td", _hoisted_55, _toDisplayString(_unref(formatAmount)(
                    _unref(quote).rentersInsurance.installmentAmount +
                      _unref(quote).rentersInsurance.serviceFee
                  )), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(quote).rentersInsurance.paymentOption == 3)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_56, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(_unref(quote).rentersInsurance.numberOfPayments - 1) + " installments (60 days apart)", 1),
                    _hoisted_57,
                    _createElementVNode("em", null, "Includes " + _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.installmentAmount)) + " + " + _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.serviceFee)) + " billing fee ", 1)
                  ]),
                  _createElementVNode("td", _hoisted_58, _toDisplayString(_unref(formatAmount)(
                    _unref(quote).rentersInsurance.installmentAmount +
                      _unref(quote).rentersInsurance.serviceFee
                  )), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_59,
        (_unref(quote).hasPersonalInsurance && _unref(quote).showAddonOnCart)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_60,
              _hoisted_61,
              _hoisted_62,
              _createElementVNode("table", _hoisted_63, [
                _createElementVNode("tbody", null, [
                  (_unref(quote).personalInsurance.paymentOption == 2)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_64, [
                        _createElementVNode("td", null, [
                          _createTextVNode(" Payment Due Today:"),
                          _hoisted_65,
                          (processingFee.value != 0)
                            ? (_openBlock(), _createElementBlock("em", _hoisted_66, [
                                _createTextVNode("Includes " + _toDisplayString(_unref(formatAmount)(_unref(quote).personalInsurance.annualAmount)) + " ", 1),
                                _createElementVNode("span", null, "+ " + _toDisplayString(_unref(formatAmount)(processingFee.value)) + " processing fee", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_67, _toDisplayString(_unref(formatAmount)(
                      _unref(quote).personalInsurance.annualAmount + processingFee.value
                    )), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(quote).personalInsurance.paymentOption == 1)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_68, [
                        _createElementVNode("td", null, [
                          _createTextVNode(" Payment Due Today:"),
                          _hoisted_69,
                          (processingFee.value != 0)
                            ? (_openBlock(), _createElementBlock("em", _hoisted_70, [
                                _createTextVNode("Includes " + _toDisplayString(_unref(formatAmount)(_unref(quote).personalInsurance.monthlyAmount)) + " ", 1),
                                _createElementVNode("span", null, "+ " + _toDisplayString(_unref(formatAmount)(processingFee.value)) + " processing fee", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_71, _toDisplayString(_unref(formatAmount)(
                      _unref(quote).personalInsurance.monthlyAmount + processingFee.value
                    )), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(quote).personalInsurance.paymentOption == 1)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_72, [
                        _hoisted_73,
                        _createElementVNode("td", _hoisted_74, _toDisplayString(_unref(formatAmount)(
                      _unref(quote).personalInsurance.monthlyAmount + processingFee.value
                    )), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})